<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :isHide="isHide"
  >
    <div slot="content">
      <lifeGuardAuditDetail v-if="dataForm.Type === 1" :dataForm="dataForm" />
      <lectureAuditDetail v-if="dataForm.Type === 2" :dataForm="dataForm" />
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import lifeGuardAuditDetail from "@/modules/zjrc/pages/workbench/backlog/lifeGuard/components/lifeGuard";
import lectureAuditDetail from "@/modules/zjrc/pages/workbench/backlog/lifeGuard/components/lecture";
import api from "@/modules/zjrc/api";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      pictureList: [], //图片数组
      fileList: [], //附件数组
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  components: {
    workbenchDetail,
    lifeGuardAuditDetail,
    lectureAuditDetail
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryTrainById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getImg();
          that.getFile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditLifeGuard(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    }
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hide >>> .el-upload-list__item-delete {
  display: none !important;
}
.hide >>> .el-icon-close {
  display: none !important;
}
.hide >>> .el-icon-close-tip {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>